type AuthState = {
  auth: {
    accessToken?: string | null;
    gaClientId?: string | null;
  };
};

const selectAuthAccessToken = (state: AuthState) => state.auth.accessToken;
const selectAuthGaClientId = (state: AuthState) => state.auth.gaClientId;

export { selectAuthAccessToken, selectAuthGaClientId };
